// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-2ba664ca] .el-upload-dragger{background:#f5f7fe;border-radius:4px;display:flex;align-items:center;justify-content:center;font-size:14px}.error-table[data-v-2ba664ca]{padding-bottom:20px}.uploading-btn[data-v-2ba664ca]{margin-right:.7143rem}[data-v-2ba664ca] .el-button--default{margin-right:0!important}[data-v-2ba664ca] .el-button:focus-visible{outline:transparent}.upload-demo[data-v-2ba664ca]{width:100%}[data-v-2ba664ca] .el-upload__tip{font-size:1rem}", ""]);
// Exports
module.exports = exports;
